var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVideoRecorder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 19,
  viewBox: "0 0 14 9",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.889 3.375V.75c0-.412-.35-.75-.778-.75H.778C.35 0 0 .338 0 .75v7.5c0 .412.35.75.778.75h9.333c.428 0 .778-.338.778-.75V5.625l3.111 3V.375l-3.111 3z",
  fill: "#6f6f6f"
})));
export default SvgVideoRecorder;